<template>
  <div class="quilty-select" @click="showPicker = true">
    <div class="title">{{ showTitle }}</div>
    <i class="icon-arrow-down-s-line t-iconfont"></i>
  </div>
  <van-popup v-model:show="showPicker" destroy-on-close position="bottom" round>
    <AiMultiPicker
      v-model:show="showPicker"
      v-model:value="statusIn"
      :items="statusInOptions"
      title="跟进质量"
      @change="handleChange"
    />
  </van-popup>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import AiMultiPicker from '@/pages/app/board-page/meeting-board/components/components/ai-multi-picker.vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['update:value', 'change'])

const showPicker = ref(false)
const statusIn = ref([])
const statusInOptions = ref([
  {
    value: 0,
    label: '无风险'
  },
  {
    value: 1,
    label: '疑似风险'
  },
  {
    value: 2,
    label: '无效'
  }
])

const showTitle = computed(() => {
  if (props.value.length === 0) {
    return '全部'
  }
  let str = ''
  statusInOptions.value.forEach((item) => {
    if (props.value.includes(item.value)) {
      str += item.label + '、'
    }
  })
  return str.slice(0, -1)
})

const handleChange = (val) => {
  emits('update:value', val)
  emits('change', val)
}

watch(
  () => props.value,
  (val) => {
    statusIn.value = val
  }
)

onMounted(() => {
  statusIn.value = props.value
})
</script>

<style lang="scss" scoped>
.quilty-select {
  flex: 0 0 auto;
  width: 132px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  margin-left: 10px;
  margin-bottom: 8px;
  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
